/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { RuleType } from './RuleType.js';
import {
    RuleTypeFromJSON,
    RuleTypeFromJSONTyped,
    RuleTypeToJSON,
} from './RuleType.js';

/**
 * 
 * @export
 * @interface CreateRuleRequest
 */
export interface CreateRuleRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateRuleRequest
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateRuleRequest
     */
    maxScore?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRuleRequest
     */
    isManual?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRuleRequest
     */
    isGlobal?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRuleRequest
     */
    isScriptAdherence?: boolean;
    /**
     * 
     * @type {RuleType}
     * @memberof CreateRuleRequest
     */
    type?: RuleType;
    /**
     * 
     * @type {string}
     * @memberof CreateRuleRequest
     */
    scriptContent?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateRuleRequest
     */
    sectionId?: number;
}

/**
 * Check if a given object implements the CreateRuleRequest interface.
 */
export function instanceOfCreateRuleRequest(value: object): boolean {
    return true;
}

export function CreateRuleRequestFromJSON(json: any): CreateRuleRequest {
    return CreateRuleRequestFromJSONTyped(json, false);
}

export function CreateRuleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRuleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'maxScore': json['maxScore'] == null ? undefined : json['maxScore'],
        'isManual': json['isManual'] == null ? undefined : json['isManual'],
        'isGlobal': json['isGlobal'] == null ? undefined : json['isGlobal'],
        'isScriptAdherence': json['isScriptAdherence'] == null ? undefined : json['isScriptAdherence'],
        'type': json['type'] == null ? undefined : RuleTypeFromJSON(json['type']),
        'scriptContent': json['scriptContent'] == null ? undefined : json['scriptContent'],
        'sectionId': json['sectionId'] == null ? undefined : json['sectionId'],
    };
}

export function CreateRuleRequestToJSON(value?: CreateRuleRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'maxScore': value['maxScore'],
        'isManual': value['isManual'],
        'isGlobal': value['isGlobal'],
        'isScriptAdherence': value['isScriptAdherence'],
        'type': RuleTypeToJSON(value['type']),
        'scriptContent': value['scriptContent'],
        'sectionId': value['sectionId'],
    };
}

